import { getContractsEndpoint } from 'common';
import { DefaultBusinessMarketApiError, DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';
import { EndpointMockDescription, MockOptions, setupMockResponses } from '@cp-shared-10/frontend-storybook-extensions';
import { CpDataApi } from 'cp-xhr';
import React from 'react';
import { BrokerDetailsMock } from '../dashboard-marketing-card/BrokerDetailsResponseMocks';
import { contractDataWithValidContracts, contractWithAllFields } from './ExampleData';
import { FinancialDetailsMock } from './financial-details';
import { InterveningPartiesMock } from './intervening-parties/InterveningPartiesResponseMocks';
import {
    VehicleDetailsResponseMock,
    VehicleImageResponseMock,
} from './vehicle-details-and-image/VehicleDetailsAndImageResponseMocks';

const mockOptions: MockOptions<DefaultBusinessMarketApiErrorCode> = {
    Success: {
        status: 201,
        responseBody: contractDataWithValidContracts,
        delay: 1000,
    },
    'Business Error': DefaultBusinessMarketApiError,
    'Unexpected/Connection Error': {
        status: 500,
    },
};

export const ContractsMock: EndpointMockDescription<DefaultBusinessMarketApiErrorCode> = {
    name: 'Contracts Response',
    method: 'get',
    defaultMockOption: 'Success',
    mockOptions,
    url: getContractsEndpoint(),
};

export const ContractsResponseMockWrapper = (storyFn: () => React.ReactNode) => {
    setupMockResponses(CpDataApi, [
        ContractsMock,
        FinancialDetailsMock(contractWithAllFields),
        InterveningPartiesMock,
        BrokerDetailsMock,
        VehicleImageResponseMock,
        VehicleDetailsResponseMock,
    ]);

    return <div>{storyFn()}</div>;
};
